export default "assets/images/phone-in-5f01bd0a.svg";